import React from 'react';
import Image from '@components/Image';
import MarkdownRenderer from '@components/MarkdownRenderer';
import TypeScale from '@identity/type';
import { Wrapper, Content } from './styles';

const PageHero = ({ backgroundImage, title, description }) => {
  return (
    <Wrapper imgBrightness="50%">
      <Image absolute src={backgroundImage.file.url} />
      <Content>
        <TypeScale.H1
          spacing={{ margin: 'bottom-sm' }}
          alignText="center"
          color="white"
        >
          {title}
        </TypeScale.H1>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {description && <MarkdownRenderer source={description.description} />}
        </div>
      </Content>
    </Wrapper>
  );
};

export default PageHero;
